/**
 * Conteúdo central do site Contato Internet.
 * Tudo que é editável (planos, banners, cards, textos, contatos) vive aqui.
 * Formato espelhado nas tabelas do painel administrativo da Contato.
 */

export const contact = {
  whatsapp: "554835210400",
  phoneDisplay: "(48) 3521-0400",
  email: "contato@contato.net",
  site: "https://www.contato.net",
};

export function whatsappLink(message: string) {
  return `https://api.whatsapp.com/send?phone=${contact.whatsapp}&text=${encodeURIComponent(message)}`;
}

export type Plan = {
  id: string;
  speed: string;
  unit: string;
  price: string;
  cents: string;
  highlight?: boolean;
  badge?: string;
  features: string[];
};

export const plans: Plan[] = [
  {
    id: "500",
    speed: "500",
    unit: "MEGA",
    price: "116",
    cents: ",80",
    features: [
      "200 Mega de upload",
      "Instalação grátis",
      "100% Fibra Óptica",
      "Wi-Fi incluso",
      "+200 canais de TV",
      "App Deezer",
    ],
  },
  {
    id: "650",
    speed: "650",
    unit: "MEGA",
    price: "144",
    cents: ",80",
    features: [
      "300 Mega de upload",
      "Instalação grátis",
      "100% Fibra Óptica",
      "Wi-Fi incluso",
      "+200 canais de TV",
      "App Deezer",
    ],
  },
  {
    id: "800",
    speed: "800",
    unit: "MEGA",
    price: "169",
    cents: ",80",
    highlight: true,
    badge: "Mais escolhido",
    features: [
      "400 Mega de upload",
      "Instalação grátis",
      "100% Fibra Óptica",
      "Wi-Fi incluso",
      "+200 canais de TV",
      "App Deezer",
    ],
  },
  {
    id: "1000",
    speed: "1000",
    unit: "MEGA",
    price: "209",
    cents: ",80",
    features: [
      "500 Mega de upload",
      "Instalação grátis",
      "100% Fibra Óptica",
      "Wi-Fi incluso",
      "+200 canais de TV",
      "App Deezer",
    ],
  },
];

export const heroSlides = [
  {
    id: "ponte",
    titleStart: "Somos a sua",
    titleAccent: "ponte de conectividade",
    text: "Conectando você ao que realmente importa.",
    ctaLabel: "Assine agora",
    ctaTo: "/planos",
  },
  {
    id: "fibra",
    titleStart: "Fibra óptica de",
    titleAccent: "verdade na sua casa",
    text: "Velocidade simétrica, Wi-Fi incluso e instalação grátis.",
    ctaLabel: "Ver planos",
    ctaTo: "/planos",
  },
  {
    id: "empresas",
    titleStart: "Estrutura completa",
    titleAccent: "para a sua empresa",
    text: "Link dedicado, telefonia, cloud e data center Tier 3.",
    ctaLabel: "Falar com consultor",
    ctaTo: "/empresas",
  },
];

export const banners = heroSlides;

export const highlights = [
  { value: "Internet", label: "Fibra + Wi-Fi\ninstalação grátis", icon: "wifi" },
  { value: "Telefone", label: "Fixo e IP\ncom portabilidade", icon: "phone" },
  { value: "Hospedagem", label: "Sites, e-mails\ne cloud", icon: "server" },
];

export const services = [
  {
    icon: "wifi",
    tag: "Internet",
    title: "Somos sua ponte de conectividade",
    text: "conectando você ao que realmente importa.",
    ctaLabel: "Ver planos",
    ctaHref: "/planos",
  },
  {
    icon: "phone",
    tag: "Telefonia",
    title: "Sua linha, sempre disponível",
    text: "transfira seu número para a contato e conecte-se a qualquer momento.",
    ctaLabel: "Contratar telefonia",
    ctaHref: "/telefonia",
  },
  {
    icon: "cloud",
    tag: "Cloud",
    title: "Armazene com segurança e acesse de qualquer lugar",
    text: "experimente a contato cloud e tenha seus dados sempre ao seu alcance, com total proteção.",
    ctaLabel: "Conhecer a Cloud",
    ctaHref: "/empresas",
  },
  {
    icon: "home",
    tag: "Smart Home",
    title: "A casa do futuro é agora",
    text: "conheça a contato smart home e torne sua vida mais prática e conectada.",
    ctaLabel: "Quero Smart Home",
    ctaHref: "whatsapp:Olá! Quero saber sobre a Contato Smart Home.",
  },
  {
    icon: "tv",
    tag: "TV Online",
    title: "Mais opções para se conectar com seus conteúdos preferidos",
    text: "acesse uma seleção completa de canais ao vivo e apps de entretenimento.",
    ctaLabel: "Assistir agora",
    ctaHref: "whatsapp:Olá! Quero saber sobre a Contato TV Online.",
  },
];

export const coverage = {
  title: "+30 cidades",
  text: "já contam com a melhor conexão, e em breve mais 15 terão conexão de verdade.",
  ctaLabel: "Consultar agora",
  ctaTitle: "Consulte área de cobertura",
};

export const headquarters = {
  name: "Matriz Araranguá",
  address: "R. Pedro João Pereira, 900",
  district: "Mato Alto, Araranguá - SC",
  zip: "88904-150",
};

export const differentials = [
  {
    icon: "zap",
    title: "Fibra óptica ponta a ponta",
    text: "Rede própria e redundante, com baixa latência para jogos, streaming e home office.",
  },
  {
    icon: "headset",
    title: "Suporte local 7 dias",
    text: "Time técnico na sua região, com atendimento humano por telefone e WhatsApp.",
  },
  {
    icon: "wifi",
    title: "Wi-Fi incluso",
    text: "Roteador de alta performance instalado e configurado por nossa equipe, sem custo extra.",
  },
  {
    icon: "shield",
    title: "Sem surpresa na fatura",
    text: "Preço claro, instalação grátis e nenhuma cobrança escondida no meio do caminho.",
  },
];

export const businessServices = [
  {
    title: "Link dedicado",
    text: "Banda garantida 1:1, IP fixo e SLA com acompanhamento proativo da nossa NOC.",
  },
  {
    title: "Telefonia IP",
    text: "Ramais, portabilidade e tarifas reduzidas integrados ao seu link de internet.",
  },
  {
    title: "Hospedagem e e-mail",
    text: "Sites, sistemas e contas de e-mail profissionais hospedados em datacenter nacional.",
  },
  {
    title: "Projetos corporativos",
    text: "Interligação de filiais, redes internas e cabeamento estruturado sob medida.",
  },
];

export const testimonials = [
  {
    name: "Kauan Rafael",
    role: "Cliente residencial",
    text: "Trocamos de operadora e a diferença foi imediata. A internet não cai e o suporte responde na hora.",
  },
  {
    name: "Renan Fernandes",
    role: "Cliente empresarial",
    text: "Nossa operação depende de conexão estável. Desde que migramos para a Contato não tivemos parada.",
  },
];

export const stats = [
  { value: "+1000", label: "empresas atendidas" },
  { value: "25 anos", label: "de estrada em telecom" },
  { value: "1 Giga", label: "de velocidade disponível" },
  { value: "7 dias", label: "de suporte por semana" },
];

export const clientPortalUrl = "https://cliente.contato.net/auth/login";

export const customerLinks = [
  {
    label: "Central do assinante",
    href: clientPortalUrl,
    desc: "Faça login e gerencie tudo do seu plano.",
  },
  { label: "Segunda via do boleto", href: clientPortalUrl, desc: "Consulte e emita a sua fatura." },
  { label: "Pague via PIX", href: clientPortalUrl, desc: "Pagamento instantâneo, sem fila." },
  { label: "Meus contratos", href: clientPortalUrl, desc: "Documentos e condições dos serviços." },
  {
    label: "Consumo e faturas",
    href: clientPortalUrl,
    desc: "Histórico de pagamentos do seu contrato.",
  },
  {
    label: "Suporte técnico",
    href: clientPortalUrl,
    desc: "Abra e acompanhe chamados de atendimento.",
  },
];

export const stores = [
  {
    city: "Matriz",
    address: "Consulte o endereço da loja mais próxima pelo WhatsApp.",
    phone: contact.phoneDisplay,
  },
];

export const footerLinks = [
  { label: "Sobre nós", to: "/sobre" },
  { label: "Planos", to: "/planos" },
  { label: "Empresas", to: "/empresas" },
  { label: "Contato", to: "/contato" },
  { label: "Área do cliente", to: "/area-do-cliente" },
];
